export default __webpack_public_path__ + "static/media/dino_showroom_220xtc_kori.6d360aac.jpg";